import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Button,
    makeStyles,
    Grid,
    Typography,
  } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
dialogActions: {
  padding: 15,
},
body: {
  marginTop: 5,
  marginBottom: 5,
},
unassignBtn: {
  marginRight: "auto",
},
}));

type ConfirmNilReturnDialogProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export const ConfirmNilReturnDialog: React.FC<ConfirmNilReturnDialogProps> = (props) => {
  const classes = useStyles();
  const {
    open,
    onClose,
    onSubmit
  } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      data-test="upload-file-dialog"
    >
      <>
        <DialogTitle data-test="upload-file-dialog-title">
          Confirm nil return
          <Divider />
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="body1">
                Are you sure you want to submit a nil return?
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            onClick={onClose}
            color="primary"
            data-test="close-upload-button"
          >
            Close
          </Button>
          <Button
            onClick={onSubmit}
            color="primary"
            data-test="confirm-upload-button"
          >
            Confirm
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}